import type { BindingScope, ProviderField } from "@tilt/admin-sdk";

/**
 * Shared scope helpers for push 13 UI. Mirrors the rules in
 * ``tilt_runtime.binding_merge`` on the backend - keeping both
 * implementations consistent is load-bearing for the "inherited"
 * block in SchemaForm and the scope-aware "Action needed" filter in
 * ProvidersTab, so they all read from here.
 */

export const SCOPE_RANK: Record<BindingScope, number> = {
  partner: 1,
  organization: 2,
  location: 3,
};

/**
 * Resolve a field's ``x-scope`` annotation. Unknown / missing values
 * fall back to ``"location"`` - the most-specific tier - so a typo
 * in a schema annotation never silently disables validation. Matches
 * the runtime helper of the same name.
 */
export function fieldScope(field: ProviderField | undefined): BindingScope {
  const raw = field?.["x-scope"];
  return raw === "partner" || raw === "organization" || raw === "location" ? raw : "location";
}
